import {
  fetchClientContactDetail,
  fetchClientDetail,
  fetchClientGroupDetail,
} from '@src/features/clients';
import type { APIClient } from '@src/shared/api';

/**
 * Name of the client for the title of the client pages. Errors are left to
 * the page, which loads the same client; the title then has no name.
 */
export async function loadClientName(
  apiClient: APIClient,
  clientId: string,
): Promise<string> {
  try {
    const client = await fetchClientDetail(apiClient, clientId);
    return client.name;
  } catch {
    return '';
  }
}

/** Name of the contact for the title of the contact page; as above. */
export async function loadContactName(
  apiClient: APIClient,
  contactId: string,
): Promise<string> {
  try {
    const contact = await fetchClientContactDetail(apiClient, contactId);
    return contact.name;
  } catch {
    return '';
  }
}

/** Name of the client group for the title of the group page. */
export async function loadClientGroupName(
  apiClient: APIClient,
  groupId: string,
): Promise<string> {
  try {
    const group = await fetchClientGroupDetail(apiClient, groupId);
    return group.name;
  } catch {
    return '';
  }
}
